import { CollectionDate, CollectionTime } from '@caresend/types';
import { changeTimeZone } from '@caresend/utils';
import dayjs from 'dayjs';
import { getStore } from '../../../../helpers/initStore.js';

/**
 * Checks if the start time adheres the collection date.
 */
const checkCollectionDate = (startTime, collectOnTimestamp, collectEndTimestamp, collectionDate) => {
    var _a;
    const store = getStore();
    if (!collectionDate || !collectOnTimestamp)
        return true;
    const timeZone = (_a = store.getters['schedulingFlow/getTimeZoneOfDraftWaypointLocation']) !== null && _a !== void 0 ? _a : dayjs.tz.guess();
    const startOf = changeTimeZone(collectOnTimestamp, timeZone);
    const startOfCollectionDay = dayjs(startOf.timestamp).tz(startOf.timeZone).startOf('day');
    const endOfCollectionDay = dayjs(startOf.timestamp).tz(startOf.timeZone).endOf('day');
    const startTimeDayjs = dayjs(startTime).tz(timeZone);
    const betweenRangeEndTzDate = changeTimeZone(collectEndTimestamp !== null && collectEndTimestamp !== void 0 ? collectEndTimestamp : 0, timeZone);
    const betweenRangeEnd = dayjs(betweenRangeEndTzDate.timestamp).tz(betweenRangeEndTzDate.timeZone).endOf('day');
    switch (collectionDate) {
        case CollectionDate.ANY:
            return true;
        case CollectionDate.ON:
            return startTimeDayjs.isAfter(startOfCollectionDay)
                && startTimeDayjs.isBefore(endOfCollectionDay);
        case CollectionDate.BEFORE:
            return startTimeDayjs.isBefore(startOfCollectionDay);
        case CollectionDate.AFTER:
            return startTimeDayjs.isAfter(endOfCollectionDay);
        case CollectionDate.BETWEEN:
            return startTimeDayjs.isAfter(startOfCollectionDay)
                && startTimeDayjs.isBefore(betweenRangeEnd);
    }
};
/**
 * Checks if the start time adheres the collection time.
 */
const checkCollectionTime = (startTime, collectionTime) => {
    const store = getStore();
    if (!collectionTime)
        return true;
    const timeZone = store.getters['schedulingFlow/getTimeZoneOfDraftWaypointLocation'];
    const startOfDay = dayjs(startTime).tz(timeZone).startOf('day');
    const startTimeDayjs = dayjs(startTime).tz(timeZone);
    const endOfDay = startOfDay.endOf('day');
    const collectOnDateNoon = startOfDay.add(12, 'hours');
    switch (collectionTime) {
        case CollectionTime.ANY:
            return true;
        case CollectionTime.AM:
            return collectOnDateNoon.isAfter(startTime);
        case CollectionTime.PM:
            return collectOnDateNoon.isBefore(startTimeDayjs) && startTimeDayjs.isBefore(endOfDay);
    }
};
/**
 * Checks if the start time adheres the collection medical restrictions
 */
const getCollectionFailure = (startTime, collectionDate, collectionTime, collectOnTimestamp, collectEndTimestamp) => {
    const collectionDateWorks = checkCollectionDate(startTime, collectOnTimestamp, collectEndTimestamp, collectionDate);
    if (!collectionDateWorks)
        return 'Collection date not compatible';
    const collectionTimeWorks = checkCollectionTime(startTime, collectionTime);
    if (!collectionTimeWorks)
        return 'Collection time not compatible';
    return null;
};

export { getCollectionFailure };
